import { ChevronDown } from "lucide-react";

const HeroSection = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="accueil"
      className="relative h-[85vh] flex items-center justify-center"
      data-testid="hero-section">

      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_ttwood-villard/artifacts/6ddk8ow2_Messenger_creation_2F6CDC62-0494-4B07-B658-4E85C12B1DF2.jpg"
          alt="Atelier de menuiserie TT Wood à Villard-Bonnot - artisan ébéniste"
          loading="eager"
          fetchpriority="high"
          decoding="async"
          className="w-full h-full object-cover object-[center_40%]" />

        <div className="hero-gradient absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 text-center">
        <div className="opacity-0 animate-fade-in-up">
          <span className="font-handwritten text-2xl md:text-3xl text-white/90 mb-4 block">Artisan ébéniste depuis 2020

          </span>
        </div>
        
        <h1
          className="font-heading text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-6 opacity-0 animate-fade-in-up animation-delay-100"
          data-testid="hero-title">

          L'Excellence du Bois
          <br />
          <span className="text-warm-cream">à Villard-Bonnot</span>
        </h1>
        
        <p
          className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-10 opacity-0 animate-fade-in-up animation-delay-200"
          data-testid="hero-subtitle">

          Menuiserie ébénisterie artisanale sur mesure. Nous créons des pièces uniques qui subliment vos espaces avec passion et savoir-faire.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center opacity-0 animate-fade-in-up animation-delay-300">
          <a
            href="#contact"
            onClick={(e) => scrollToSection(e, "#contact")}
            className="btn-primary text-base"
            data-testid="hero-cta-primary">

            Demander un devis gratuit
          </a>
          <a
            href="#realisations"
            onClick={(e) => scrollToSection(e, "#realisations")}
            className="bg-white/10 backdrop-blur-sm text-white border border-white/30 hover:bg-white/20 rounded-full px-8 py-3 transition-all duration-300 font-medium"
            data-testid="hero-cta-secondary">

            Voir nos réalisations
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <a
        href="#apropos"
        onClick={(e) => scrollToSection(e, "#apropos")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/70 hover:text-white transition-colors animate-bounce"
        aria-label="Défiler vers le bas"
        data-testid="scroll-indicator">

        <ChevronDown size={32} />
      </a>
    </section>);

};

export default HeroSection;